// extracted by mini-css-extract-plugin
export default {"priority-switch":"TestimonialList_priority-switch__1PqxO","infooutlined-alignment":"TestimonialList_infooutlined-alignment__ArTGX"};